import { RefiMenu } from './menu.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';
import '../../class-map.js';
import '../../directive.js';
import '../../styles/reset.style.js';
import '../../utils/get-focusable-elements.js';

defineRefiElement('refi-common-menu', RefiMenu);
